import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {useAccountApplication} from "../../account-applications/hooks/useAccountApplication";
import {AccountApplication} from "../../account-applications/types";
import {Application} from "../types.ts";
import {AiOutlineCheck} from 'react-icons/ai';

export const EnableRecordButton = ({
                                       record
                                   }: {
    record: Application
}) => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('User account not found');
    }
    const {createRecord} = useAccountApplication(userAccount.id)

    const onClick = () => {
        createRecord({
                         accountId: userAccount.id,
                         applicationId: record.id,
                     } as AccountApplication);
    };
    return (
        <FlexiButton
            leftSection={<AiOutlineCheck/>}
            onClick={onClick}
            size={'md'}
        >
            {I18n.get('Enable')}
        </FlexiButton>
    );
};
